export const FETCH_SHORT_COLLECTION = 'FETCH_SHORT_COLLECTION'
export const RESET_SHORT_COLLECTION = 'RESET_SHORT_COLLECTION'
